import { z } from 'zod';

/////////////////////////////////////////
// CORE ELASTICSEARCH MAID MODEL MAX TIMESTAMP SCHEMA
/////////////////////////////////////////

export const CoreElasticsearchMaidModelMaxTimestampSchema = z.object({
  id: z.number().int(),
  modelName: z.string(),
  maxTimestamp: z.coerce.date(),
})

export type CoreElasticsearchMaidModelMaxTimestamp = z.infer<typeof CoreElasticsearchMaidModelMaxTimestampSchema>

export default CoreElasticsearchMaidModelMaxTimestampSchema;
